import React, { Component } from 'react'
import Web3 from 'web3'
import { WHITEWHALE_ABI, WHITEWHALE_ADDRESS } from './config'


class SmartInfo extends Component {
  componentDidMount(){
    this.getInfo()
  }

    async getInfo(){
    const web3 = new Web3("https://api.harmony.one")
    const whiteWhale = new web3.eth.Contract(WHITEWHALE_ABI, WHITEWHALE_ADDRESS)
    const owner = await whiteWhale.methods.owner().call()
    const pricePaid = await whiteWhale.methods.pricePaid().call()
    this.setState({ owner , pricePaid })
    console.log(owner)

  }




constructor(props) {
  super(props)
  this.state = {
    owner: '' ,
    pricePaid: ''
  }
}



  render() {


    return (
      <div>
      <h3>owner: <br />{this.state.owner}</h3>
      <h3>pricePaid: <br />{ this.state.pricePaid / 10**18 } ONE</h3>

      </div>
    );
  }

}


export default SmartInfo;
